import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ArrowUpRight, ChevronDown, Instagram, Menu, MoveUpRight, Sparkles, X } from "lucide-react";
import { useState } from "react";

const services = [
  { number: "01", title: "Brand-led websites", copy: "Digital homes with a point of view — built to make your best first impression feel inevitable." },
  { number: "02", title: "Conversion systems", copy: "Clear journeys, sharp copy and thoughtful interaction that turn attention into action." },
  { number: "03", title: "Webflow & React builds", copy: "Fast, flexible foundations that look immaculate today and stay easy to grow tomorrow." },
];

function Logo() {
  return <a className="logo" href="#top" data-testid="brand-logo"><span className="logo-mark">M<span className="logo-spark">✦</span></span><span className="logo-word">MONOWEB</span></a>;
}

const Home = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  return (
    <main id="top" data-testid="monoweb-homepage">
      <nav className="nav shell" data-testid="main-navigation">
        <Logo />
        <button className="mobile-menu" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu" data-testid="mobile-menu-button">{menuOpen ? <X size={20} /> : <Menu size={20} />}</button>
        <div className={`nav-links ${menuOpen ? "is-open" : ""}`}>
          <a href="#contact" onClick={closeMenu} data-testid="nav-contact-link">Contact</a>
          <a className="nav-cta" href="#contact" onClick={closeMenu} data-testid="nav-start-project-link">Start a project <ArrowUpRight size={15} /></a>
        </div>
      </nav>

      <section className="hero shell" data-testid="hero-section">
        <div className="hero-grid" />
        <div className="hero-copy">
          <div className="eyebrow reveal"><span className="eyebrow-dot" /> Independent digital studio</div>
          <h1 className="reveal delay-1">Websites with <em>presence.</em></h1>
          <p className="hero-text reveal delay-2">MonoWeb creates considered digital experiences for ambitious brands that refuse to blend in.</p>
          <div className="hero-actions reveal delay-3">
            <a className="text-link" href="#services" data-testid="hero-approach-link">See our approach <MoveUpRight size={16} /></a>
          </div>
        </div>
        <div className="hero-art reveal delay-2" aria-label="Abstract purple glass sculpture" data-testid="hero-artwork">
          <div className="orb orb-one" /><div className="orb orb-two" /><div className="orb orb-three" />
          <div className="art-label"><span>Scroll to explore</span><ChevronDown size={14} /></div>
          <div className="art-caption">Digital<br /><strong>with intent.</strong></div>
        </div>
        <div className="hero-meta" data-testid="hero-meta"><span>Scroll down</span><span className="meta-line" /><span>01 / 04</span></div>
      </section>

      <section className="statement shell" data-testid="statement-section">
        <p className="section-kicker">The MonoWeb difference</p>
        <h2>Not just another <span>pretty website.</span><br />A sharper way to show up.</h2>
      </section>

      <section className="services shell" id="services" data-testid="services-section">
        <div className="section-head"><div><p className="section-kicker">What we do</p><h2>Built around<br /><span>your ambition.</span></h2></div><p className="section-intro">The right digital presence is more than a surface. It is a strategic tool, a sales partner, and a signal of where you’re going.</p></div>
        <div className="service-list">{services.map((service) => <article className="service-item" key={service.number} data-testid={`service-${service.number}`}><span className="service-number">{service.number}</span><h3>{service.title}</h3><p>{service.copy}</p><ArrowUpRight className="service-arrow" size={20} /></article>)}</div>
      </section>

      <section className="why shell" data-testid="why-section">
        <div className="why-card"><div className="why-glow" /><p className="section-kicker">Why MonoWeb</p><h2>Good design<br />makes <em>noise.</em></h2><p className="why-copy">We pair strategic thinking with a meticulous eye for detail, so every scroll feels intentional and every page earns its place.</p><a className="text-link light" href="#contact" data-testid="why-contact-link">Tell us what you are building to let us help to get your business online <ArrowUpRight size={16} /></a></div>
        <div className="principles"><div className="principle"><span>01</span><strong>Clarity over clutter</strong><p>We make the important thing impossible to miss.</p></div><div className="principle"><span>02</span><strong>Distinct by default</strong><p>Your website should sound and look like no one else.</p></div><div className="principle"><span>03</span><strong>Details that matter</strong><p>The little moments are where trust is built.</p></div></div>
      </section>

      <section className="contact shell" id="contact" data-testid="contact-section"><div className="contact-inner"><Sparkles size={22} className="contact-spark" /><p className="section-kicker">Have a good feeling?</p><h2>Let’s make your<br /><em>website unforgettable.</em></h2><p>Tell us a little about what you’re building. We’ll take it from there.</p><div className="contact-actions" data-testid="contact-actions"><a className="button button-primary" href="https://mail.google.com/mail/?view=cm&fs=1&to=websitesbyakshit%40gmail.com&su=Website%20project%20enquiry" target="_blank" rel="noreferrer" data-testid="contact-email-cta">Email us <ArrowUpRight size={17} /></a><a className="button button-social" href="https://www.instagram.com/mono._web/" target="_blank" rel="noreferrer" data-testid="contact-instagram-cta"><Instagram size={17} /> Instagram <ArrowUpRight size={15} /></a></div></div></section>

      <footer className="footer shell" data-testid="site-footer"><Logo /><a href="#top" data-testid="footer-top-link">Back to top ↑</a></footer>
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}>
            <Route index element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
